import Divider from '@/component/Divider'
import TGASDK from '@/config/TGASDK'
import useStatePopup from '@/hook/useStatePopup'
import { PopupSelector } from '@/store/PopupStore'
import { Wallet } from '@kulee/tga-sdk'
import React, { Suspense, useEffect } from 'react'
import { useTranslation } from 'react-i18next'

const PayMain: React.FC<PropType> = () => {
  const { t } = useTranslation('wallet')
  const { commodity, quantity } = useStatePopup(PopupSelector.payPopup)

  useEffect(() => {
    TGASDK.addModule(Wallet)
  }, [])

  return (
    <div className="flex h-full flex-col">
      <div className="flex justify-between items-center gap-md font-semibold px-md">
        <div>{commodity?.name}</div>
        <div className="text-primary-dark text-2xl">
          {commodity?.prefix}
          {(commodity?.price! * quantity!).toFixed(2)}
        </div>
      </div>
      <Divider />
      <div className="flex flex-col gap-sm flex-grow">
        <div className="px-md text-left">{t('title.payMethod')}</div>
        {commodity && (
          <Suspense fallback="loading...">
            {
              // 只有需要时才触发 import
              React.createElement(React.lazy(() => import('../StripePayment')))
            }
          </Suspense>
        )}
      </div>
    </div>
  )
}

interface PropType {}

export default PayMain
